// This file was automatically generated from appchart.dialog.addMedOrderTemplate.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.addMedOrderTemplate');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addMedOrderTemplate.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer el8StandardFontSize"><form id="add-med-order-template-form" data-id="', soy.$$escapeHtml(opt_data.medicationId), '"><div class="el8Wrap">Medication: <span class="el8Medium">', soy.$$escapeHtml(opt_data.name), '</span></div><div class="el8Wrap">Sig: <span class="el8Medium">', soy.$$escapeHtml(opt_data.directions), '</span></div><div class="el8Wrap">Quantity: <span class="el8Medium">', soy.$$escapeHtml(opt_data.qty), ' ', soy.$$escapeHtml(opt_data.qtyUnits), '</span></div><div class="el8Wrap">Refills: <span class="el8Medium">', soy.$$escapeHtml(opt_data.authRefills), '</span></div></form></div>');
  if (!opt_sb) return output.toString();
};
